import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
    TranslationStatusNotification,
    TranslationStatusService
} from '../../services/translation-status.service';

@Component({
    selector: 'app-translation-status-notifications',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './translation-status-notifications.component.html',
    styleUrl: './translation-status-notifications.component.css'
})
export class TranslationStatusNotificationsComponent {
    private readonly translationStatusService = inject(TranslationStatusService);

    readonly notifications = this.translationStatusService.notifications;

    dismiss(notificationId: string): void {
        this.translationStatusService.dismiss(notificationId);
    }

    getRole(notification: TranslationStatusNotification): 'alert' | 'status' {
        return notification.state === 'error' ? 'alert' : 'status';
    }
}
